module.exports = __webpack_public_path__ + "static/great-dane-training-fcf5299f9685b652a953be70239b2a7c.jpg";